import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import Divider from '@material-ui/core/Divider';
import { TP } from '../../constants/consts';
import SimpleModal from '../Modal';
import { EditModeCardSection } from '../EditModeCard';
import { SaveButtonBlock } from '../EditComponents/SaveButtonBlock';
import { colors, fontSize } from '../../constants/styleConstants';
import H3 from '../H3';

const useStyles = makeStyles(theme => ({
  modal: {
    width: 'calc(100% - 290px)',
    right: 0,
    left: 'auto',
    top: 0,
    transform: 'none',
    margin: 25,
  },
  root: {
    backgroundColor: colors.white,
  },
  header: {
    display: 'flex',
    fontSize: fontSize.basic,
    color: colors.secondaryTitleColor,
  },
  title: {
    fontSize: '18px',
    color: colors.secondaryTitleColor,
    lineHeight: '18px',
    marginBottom: '10px',
    fontWeight: 'bold',
  },
  boldText: {
    fontWeight: 'bold!important',
    color: colors.secondaryTitleColor,
  },
  subTitleItem: {
    lineHeight: '17px',
  },
  divider: {
    margin: '0 5px',
    backgroundColor: colors.secondaryTitleColor,
  },
  scrollable: {
    maxHeight: 'calc(100vh - 188px)',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  footer: {
    padding: theme.spacing(2),
    backgroundColor: colors.white,
    boxShadow:
      '0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 24px 38px 3px rgba(0, 0, 0, 0.14)',
  },
  [theme.breakpoints.down('sm')]: {
    modal: {
      width: 'calc(100% - 50px)',
      right: '0px',
      left: 'auto',
      top: '0',
      transform: 'none',
      margin: '25px',
    },
  },
}));

const SubmitModalLayout = ({
  isOpened,
  onClose,
  title1,
  title2,
  children,
  updatedDate,
  modalTitle,
  footer,
  submitFunc,
  withoutFooter,
  disableBackdropClick,
  className,
  isLoading,
  contentClassname,
}) => {
  const classes = useStyles();

  return (
    <SimpleModal
      isModalOpen={isOpened}
      onClose={onClose}
      className={cn(classes.modal, className)}
      disableBackdropClick={disableBackdropClick}
    >
      <EditModeCardSection first>
        {modalTitle && <H3 className={classes.title}>{modalTitle}</H3>}
        <div className={classes.header}>
          <div className={cn(classes.boldText, classes.subTitleItem)}>{title1}</div>
          {title2 && (
            <>
              <Divider orientation="vertical" flexItem classes={{ root: classes.divider }} />
              <div className={classes.subTitleItem}>{title2}</div>
            </>
          )}
        </div>
      </EditModeCardSection>
      <Divider />
      <div className={cn(classes.scrollable, contentClassname)}>{children}</div>
      {!withoutFooter && (
        <div className={classes.footer}>
          {footer || (
            <SaveButtonBlock
              updatedDate={updatedDate}
              buttonText={`${TP}.m_SAVE`}
              buttonVariant="contained"
              onSaveClick={submitFunc}
              isLoading={isLoading}
            />
          )}
        </div>
      )}
    </SimpleModal>
  );
};

SubmitModalLayout.propTypes = {
  isOpened: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  title1: PropTypes.string.isRequired,
  title2: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node.isRequired,
  updatedDate: PropTypes.string,
  modalTitle: PropTypes.string,
  footer: PropTypes.node,
  submitFunc: PropTypes.func,
  withoutFooter: PropTypes.bool,
  disableBackdropClick: PropTypes.bool,
  className: PropTypes.string,
  contentClassname: PropTypes.string,
  isLoading: PropTypes.bool,
};

SubmitModalLayout.defaultProps = {
  onClose: () => {},
  modalTitle: null,
  footer: null,
  updatedDate: '',
  submitFunc: () => {},
  withoutFooter: false,
  disableBackdropClick: false,
  isLoading: false,
  contentClassname: '',
};

export default SubmitModalLayout;
